const GraphIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
    >
      <defs>
        <clipPath id="graphIconClipPath">
          <path
            data-name="사각형 32244"
            style={{ fill: '#fff' }}
            d="M0 0h20.571v24H0z"
          />
        </clipPath>
      </defs>
      <g data-name="ic / 24 / graph / white">
        <path
          data-name="사각형 32243"
          style={{ fill: 'none' }}
          d="M0 0h24v24H0z"
        />
        <g data-name="그룹 45156">
          <g
            data-name="그룹 45155"
            style={{ clipPath: 'url(#graphIconClipPath)' }}
            transform="translate(1.715)"
          >
            <path
              data-name="패스 16461"
              d="M208.862 112.9V97.607a1.736 1.736 0 0 1 1.817-1.818h2.009a1.71 1.71 0 0 1 1.8 1.8v13.333a3.361 3.361 0 0 1-.052.691 1.651 1.651 0 0 1-1.559 1.314c-1.311.02-2.623.005-3.934 0a.37.37 0 0 1-.079-.028"
              transform="translate(-193.918 -88.938)"
              style={{ fill: '#fff' }}
            />
            <path
              data-name="패스 16462"
              d="M107.518 157.31h-5.942v-.3c0-3.83.019-7.66-.011-11.49a1.826 1.826 0 0 1 1.92-1.921c.748.035 1.5 0 2.249.008a1.735 1.735 0 0 1 1.791 1.768q.008 5.879 0 11.758c0 .052-.005.1-.009.176"
              transform="translate(-94.298 -133.325)"
              style={{ fill: '#fff' }}
            />
            <path
              data-name="패스 16463"
              d="M5.55 179.661v11.119c-.09.005-.167.014-.245.014H1.771A1.707 1.707 0 0 1 0 189.018v-7.6a1.7 1.7 0 0 1 1.754-1.762h3.56c.07 0 .14.006.233.011"
              transform="translate(0 -166.796)"
              style={{ fill: '#fff' }}
            />
            <path
              data-name="패스 16464"
              d="M46.18 3.183c-.115.155-.229.31-.347.463a15.541 15.541 0 0 1-5.716 4.524c-.944.454-1.941.8-2.922 1.173a1.12 1.12 0 0 1-.573.049.825.825 0 0 1-.664-.8.874.874 0 0 1 .615-.845c.8-.294 1.62-.553 2.4-.906a14.015 14.015 0 0 0 5.5-4.229c.2-.268.388-.553.627-.895h-.309c-.464 0-.928 0-1.392-.009a.852.852 0 0 1-.85-.854.842.842 0 0 1 .842-.854q1.847 0 3.693.037a.813.813 0 0 1 .832.834q.033 1.807.035 3.614a.841.841 0 0 1-.863.838.854.854 0 0 1-.845-.831c-.009-.214 0-.428-.005-.642s0-.426 0-.639l-.059-.026"
              transform="translate(-33.385 .001)"
              style={{ fill: '#fff' }}
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default GraphIcon
